// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inline[data-v-14071058]{margin-left:5px}.tips[data-v-14071058]{padding-left:20px}.name[data-v-14071058]{margin-bottom:10px}.ellips2[data-v-14071058]{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;max-height:45px}", ""]);
// Exports
module.exports = exports;
